import { z } from 'zod'
import { hearingCircumstancesInit, hearingCircumstancesScheme } from './hearing-circumstances.type'
import { hearingGeneralDataInit, hearingGeneralDataSchema } from './hearing-general-data.type'
import {
  hearingIdentificationInit,
  hearingIdentificationSchema,
} from './hearing-identification.type'
import { hearingNarrativesInit, hearingNarrativesScheme } from './hearing-narratives.type'
import { prosecutorInit, prosecutorSchema } from './prosecutor.type'

export const hearingSummaryScheme = z.object({
  dadosGerais: hearingGeneralDataSchema,
  identAdolescente: hearingIdentificationSchema,
  circFatoApreensao: hearingCircumstancesScheme,
  narrativa: hearingNarrativesScheme,
  promotor: prosecutorSchema,
})

export type HearingSummaryType = z.infer<typeof hearingSummaryScheme>

export type SummaryResponseType = { message: string; errors: string[] }

export const hearingSummaryInit: HearingSummaryType = {
  dadosGerais: hearingGeneralDataInit,
  identAdolescente: hearingIdentificationInit,
  circFatoApreensao: hearingCircumstancesInit,
  narrativa: hearingNarrativesInit,
  promotor: prosecutorInit,
}
